import { useCallback } from 'react'
import { getBudgetTotals, getExecutionDue } from '../utils/functions'

export function useExecutionDueUpdate({ getValues, setValue }) {
  const updateExecutionDue = useCallback(() => {
    const values = getValues()

    const { laborTimeTotal } = getBudgetTotals(values.inspectionBudgetCompartments || [])

    const executionDue = getExecutionDue(laborTimeTotal)
    const additionalExecutionDue = values.additionalExecutionDue ?? 0

    setValue('executionDue', executionDue, { shouldValidate: true })
    setValue('executionDueTotal', executionDue + additionalExecutionDue, {
      shouldValidate: true,
    })
  }, [getValues, setValue])

  return { updateExecutionDue }
}
